import * as React from 'react';
import styled from 'styled-components';

const OuterContainer = styled.div`
    background: #005eb8;
    padding: 5px;
    flex: 1 1 auto;
    display: flex;
`;

const InnerContainer = styled.div`
    background: #005eb8;
    color: #ffffff;
    border: 5px solid #ffffff;
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
`;

interface IProps {
    children?: any
};

export default (props: IProps) => {
    return <OuterContainer>
        <InnerContainer>
            {props.children}
        </InnerContainer>
    </OuterContainer>;
};



// WEBPACK FOOTER //
// ./src/SharedComponents/ContentWrapper.tsx